export default __webpack_public_path__ + "static/media/01.557afd69.jpg";